import { post } from "@/utils/http";
class login {
  //保存客户申请信息
  saveCustomerApplyInfo(parme){
      return post(
          'rs/miniWeChat/saveCustomerApplyInfo',parme
      )
  }
  // 线索录入中 所属行业，月发货量
  getCustomerApplyInfoEnum(){
    return post(
        'rs/miniWeChat/getCustomerApplyInfoEnum'
    )
  }
  // 手机号查询crm客户编码
  queryCrmCustomerByTelephone(parme){
    return post(
        '/login/queryCrmCustomerByTelephone',parme
    )
  }
  // getCustomerApplyInfo
    // 手机号查询提交信息
    getCustomerApplyInfo(parme){
      return post(
          '/login/getCustomerApplyInfo',parme
      )
    }
  // 保存申请信息  /miniWeChat/saveCustomerApplyInfo  上送参数 phoneNum ， customerName， address ， industry ， logisticsCost
// export function saveCustomerApplyInfo(params){
//   return $http.post('rs/miniWeChat/saveCustomerApplyInfo',params)
// }

// // 手机号查询客户编码  /miniWeChat/queryCrmCustomerByTelephone  上送参数 phoneNum
// export function queryCrmCustomerByTelephone(params){
//   return $http.post('rs/miniWeChat/queryCrmCustomerByTelephone',params)
// }

// // 线索录入中 所属行业，月发货量cubcb2b/rs/miniWeChat/getCustomerApplyInfoEnum
// export function   etCustomerApplyInfoEnum(){
//   return $http.post('rs/miniWeChat/getCustomerApplyInfoEnum')
// }

// // 线索录入合同 /miniWeChat/getCustomerApplyInfo  上送参数 phoneNum
// export function getCustomerApplyInfo(params){
//   return $http.post('rs/miniWeChat/getCustomerApplyInfo',params)
// }
}
export default login